import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Page } from '../../components';
import { Box } from '../../components/layout';
import { Button } from '../../components/widgets';
import {
  ChannelLayoutPreview,
} from 'signoxe/components/widgets';
import { getChannel, getPlaylists } from '../../selectors';
import { requestFullscreenHelper } from '../../utils/fullscreen';
import './styles.scss';

class ChannelPreviewPage extends Component {

  constructor(props) {
    super(props);
    this.state = {
      mediaIndex: 0,
      tickerIndex: 0,
    };
  }

  static propTypes = {
    tickers: PropTypes.array,
    channel: PropTypes.object,
    ticker: PropTypes.object,
    match: PropTypes.object,
  };

  handleFullScreen = () => requestFullscreenHelper(this.fullScreenElement);

  nextMedia = () =>
    this.setState({
      mediaIndex: (this.state.mediaIndex + 1) % this.props.playlist.items.length,
    })

  nextTicker = () =>
    this.setState({
      tickerIndex: (this.state.tickerIndex + 1) % this.props.ticker.tickers.length,
    })

  getMedia() {
    if (this.props.playlist && this.props.playlist.items && this.props.playlist.items.length > 0) {
      return this.props.playlist.items[this.state.mediaIndex].item;
    }
  }

  getTicker() {
    if (this.props.ticker && this.props.ticker.tickers && this.props.ticker.tickers.length > 0) {
      return this.props.ticker.tickers[this.state.tickerIndex];
    }
    else return null;
  }

  render() {

    if (!this.props.channel || !this.props.channel.regions) return null;

    const width = 800;

    return (
      <Page className="channel-preview-page">
        <Box direction="row" justifyContent="flex-end">
          <Button onClick={this.handleFullScreen}>View in Fullscreen</Button>
        </Box>
        <div ref={(el) => this.fullScreenElement = el} style={{width: (width + 2) + 'px'}}>
          <ChannelLayoutPreview
            regions={this.props.channel.regions}
            playlists={this.props.playlists}
            tickerId={this.props.channel.ticker_series}
            layoutHeight={450}
            layoutWidth={width}
          />
        </div>
      </Page>
    );
  }

}

export default connect((state, {match}) => ({
  channel: getChannel(state, parseInt(match.params.channelId)),
  playlists: getPlaylists(state)
}))(ChannelPreviewPage);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/containers/ChannelPreviewPage/index.js